export default __webpack_public_path__ + "static/media/pin-location.c0995987.svg";